import React, { useEffect } from "react";
import { EntityId } from "@reduxjs/toolkit";
import { Checkbox } from "antd";
import { fetchCategories } from "src/actions/community/categoriesActions";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import ListVertical from "src/componets/ListVertical";
import { CategoryInterface, selectSilentIds, selectSilentCount } from "src/store/community/categoriesSlice";
import Loading from "src/componets/Loading";

interface propsInterface {
  app_id: number | undefined;
  target: string;
  loading?: boolean;
  selectable?: boolean;
  selectedIds?: number[];
  onSelect?: (ids: number[]) => void;
}

const _PreviewList = ({ app_id, target, loading, selectable, selectedIds, onSelect } : propsInterface) => {
  const dispatch = useAppDispatch();
  const ids = useAppSelector(state => app_id ? selectSilentIds(state, app_id) : []);
  const count = useAppSelector(state => app_id ? selectSilentCount(state, app_id) : 0);
  const categories = useAppSelector(state => state.community.categories.entities);

  const toggleCategory = (id: number, checked: boolean) => {
    if (!onSelect) { return; }

    const current = selectedIds || [];
    onSelect(checked ? [...current, id] : current.filter(item => item !== id));
  }

  const renderCategory = (id: EntityId) => {
    const category: CategoryInterface | undefined = categories ? categories[id] : undefined;

    if (!category) {
      return null;
    }

    return (
      <ListVertical.Item
        key={category.id}
        image={category.thumbnail_url}
      >
        {selectable ? (
          <Checkbox
            checked={selectedIds?.includes(category.id)}
            onChange={e => toggleCategory(category.id, e.target.checked)}
          >
            {category.name}
          </Checkbox>
        ) : category.name}
      </ListVertical.Item>
    )
  }

  useEffect(() => {
    const params = { app_id, target };
    if (!app_id || !target || loading) {
      return;
    }

    dispatch(fetchCategories({ params, silentId: app_id }));
  }, [app_id, target, loading, dispatch]);

  return (
    <>
      <h6 className="v-content-label o-sm">Categories { count }</h6>
      <Loading loading={loading} />

      <ListVertical>
        { ids && categories && ids.map(renderCategory) }
      </ListVertical>
    </>
  );
}

export default _PreviewList;
